exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-title[data-v-123962b1] {\n  font-size: 32px;\n  font-weight: bold;\n  color: #0B486B;\n  margin-bottom: 1rem;\n}", ""]);

// exports
